/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

export const toPercentage = (value: string) => {
  if (typeof value !== "string") return "";
  const percentage = Number(value) * 1000;

  return (Math.round(percentage) / 10).toString();
};
